<template>
  <modal
    class="c-modal"
    name="bookmarks"
    draggable=".c-modal-topbar"
    classes="c-modal--style"
    :resizable="true"
    height="600"
    @before-open="beforeOpen"
  >
    <div class="c-modal-topbar">
      <div class="c-modal-topbar__move">
        <img class="c-modal-topbar__move--icon" src="/icon/move.svg" alt="">
      </div>

      <div
        class="c-modal-topbar__close"
        tabindex="1"
        @click="$modal.hide('bookmarks')"
      >
        <img class="c-modal-topbar__close--icon" src="/icon/close.svg" alt="">
      </div>
    </div>

    <div class="c-modal-content" v-html="content"></div>
  </modal>
</template>

<script>
export default {
  name: 'TheModal',

  data() {
    return {
      content: null,
    };
  },

  methods: {
    beforeOpen(e) {
      this.content = e.params.content;
    },
  },
};
</script>

<style>
.c-modal-topbar {
  padding: 8px 10px;
  background: #2e2d84;
  display: flex;
  justify-content: space-between;
}

.c-modal--style {
  background: #fff;
  border: 3px solid #2e2d84!important;
}

.c-modal-content {
  color: #2e2d84;
  font-size: 18px;
  padding: 30px;
  position: absolute;
  top: 50px;
  right: 0;
  left: 0;
  bottom: 0;
  overflow-y: scroll;
}

.c-modal-topbar__move,
.c-modal-topbar__close {
  display: inline-block;
  width: 30px;
}

.c-modal-topbar__close {
  cursor: pointer;
}

.c-modal-topbar__move--icon {
  cursor: move;
}

.c-modal-topbar__close--icon {
  width: 30px;
}
</style>
